import { Textfit } from '@wwe-portal/ui/components/text-fit';

import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { type SubscriptionTier } from '@wwe-portal/entities/subscription.type';
import { useMissionTimeLeft } from '@wwe-portal/ui/features/club-store/milestone/hooks/use-count-down-time-left';
import { OfferQuantity } from '@wwe-portal/ui/features/offer/component/offer-quantity';
import { useTimeLeft } from '@wwe-portal/ui/lib/hooks';

import { TierBadge } from '../exclusive-items/tier-badge';
import { RewardListDescription } from '../../reward/reward-list-description';

export interface MilestoneRewardDetailsProps {
  tier?: SubscriptionTier;
  title?: string;
  description: string;
  detailsDescription: string;
  timer?: string;
  rewardList: string[];
  cardBanner?: React.ReactNode;
  actionBtn?: React.ReactNode;
  quantity?: number;
  missionType?: number;
}
const Timer = ({ timer }: { timer: string | undefined }) => {
  const { getTimeText } = useTimeLeft(timer ? new Date(timer) : null);
  const timeText = getTimeText();
  return <>{timeText}</>;
};

const MissionTimer = ({ missionType }: { missionType: number }) => {
  const { timeLeftText } = useMissionTimeLeft(missionType);
  const getTimeLeftText = timeLeftText();
  return <>{getTimeLeftText}</>;
};

const CountDownTimer = ({
  timer,
  missionType,
}: {
  timer: string | undefined;
  missionType?: number;
}) => {
  if (!timer && !missionType) return null;

  return (
    <div className="flex h-[14px] w-[70px] items-center justify-start">
      <IcoMoonIcon className="text-yellow800 mr-1 size-3" iconName="timer" />

      <div className="inset-0 left-4 font-semibold leading-[14px] text-white">
        <Textfit
          className="flex h-full w-full items-center leading-[14px]"
          max={11}
          mode="single"
        >
          {missionType ? (
            <MissionTimer missionType={missionType} />
          ) : (
            <Timer timer={timer} />
          )}
        </Textfit>
      </div>
    </div>
  );
};

// TODO: move this to offer feature
export default function MilestoneRewardDetails({
  tier,
  description,
  timer,
  rewardList,
  detailsDescription,
  cardBanner,
  actionBtn,
  quantity,
  title,
  missionType,
}: Readonly<MilestoneRewardDetailsProps>) {
  return (
    <div className="font-poppins h-full w-full break-all rounded-[10px] px-4 py-6">
      {cardBanner}
      {title && (
        <div className="text-goldtier py-1 text-sm font-semibold leading-[17px]">
          {title}
        </div>
      )}
      {tier && (
        <div className="pt-5">
          <TierBadge
            className="www-h-5 w-[68px] text-xs font-normal leading-[30px]"
            tier={tier}
          />
        </div>
      )}

      <div className="text-text300 mt-[10px] py-0 text-sm font-semibold leading-[18px]">
        {description}
      </div>
      <div className="text-text400 pb-5 text-xs font-normal leading-[18px]">
        {detailsDescription}
      </div>
      {quantity != null && (
        <div className="inline-block">
          <div className="border-text700 text-text400 flex h-[28px] items-center justify-center gap-1 rounded border-[1px] border-solid bg-[#2E334D] px-[10px] py-1 text-xs font-normal">
            <OfferQuantity quantity={quantity} />
          </div>
        </div>
      )}
      <RewardListDescription rewards={rewardList} />
      {(Boolean(missionType) || timer != null) && (
        <div className="flex w-[200px] items-center justify-start pt-1">
          <div className="text-text300 font-poppins text-xs font-medium">
            <CountDownTimer missionType={missionType} timer={timer} />
          </div>
        </div>
      )}
      <div className="mt-6">{actionBtn}</div>
    </div>
  );
}
